import { render, staticRenderFns } from "./ChatCustomer.vue?vue&type=template&id=45555dce&scoped=true"
import script from "./ChatCustomer.vue?vue&type=script&lang=js"
export * from "./ChatCustomer.vue?vue&type=script&lang=js"
import style0 from "./ChatCustomer.vue?vue&type=style&index=0&id=45555dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45555dce",
  null
  
)

export default component.exports